import { getRequestContext } from "~/lib/requestContext";
import axios from "axios";
import { merge } from "lodash";
import QueryString from "qs";

export type { PaginatedResponse } from "./types";

const createAxiosInstance = (baseURL: string) => {
  return axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      accept: "*/*",
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_ITIN_API_KEY}`,
    },
    withCredentials: true,
    paramsSerializer: (params) =>
      QueryString.stringify(params, { arrayFormat: "brackets" }),
  });
};

export const tourismoApiClientSide = createAxiosInstance("/api/tourismo-api");

export const tourismoApiServerSide = createAxiosInstance(
  `${process.env.NEXT_PUBLIC_ITIN_API_URL}/api/v2`,
);

tourismoApiServerSide.interceptors.request.use((request) => {
  const { requestParams } = getRequestContext();
  return merge({}, request, requestParams);
});

export const apiClient = () => {
  const { serverSide = typeof window === "undefined" } = getRequestContext();
  return serverSide ? tourismoApiServerSide : tourismoApiClientSide;
};
